export default __webpack_public_path__ + "static/media/miniLogo.094578fb.png";